/**
 * Elapsed time tracker for recording sessions.
 * Excludes paused durations and formats as HH:MM:SS.
 */
export default class Timer {
  constructor({ onTick }) {
    this.onTick = onTick;
    this.elapsed = 0;
    this.intervalId = null;
    this.lastTick = null;
  }

  start() {
    this.elapsed = 0;
    this.lastTick = Date.now();
    this.intervalId = setInterval(() => this.tick(), 1000);
    this.onTick(this.formatted());
  }

  pause() {
    this.accumulate();
    clearInterval(this.intervalId);
    this.intervalId = null;
    this.lastTick = null;
  }

  resume() {
    this.lastTick = Date.now();
    this.intervalId = setInterval(() => this.tick(), 1000);
  }

  stop() {
    this.accumulate();
    clearInterval(this.intervalId);
    this.intervalId = null;
    this.lastTick = null;
  }

  elapsedSeconds() {
    return Math.floor(this.elapsed / 1000);
  }

  formatted() {
    const total = this.elapsedSeconds();
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    return [hours, minutes, seconds]
      .map(n => String(n).padStart(2, "0"))
      .join(":");
  }

  // private

  tick() {
    this.accumulate();
    this.lastTick = Date.now();
    this.onTick(this.formatted());
  }

  accumulate() {
    if (this.lastTick !== null) {
      this.elapsed += Date.now() - this.lastTick;
    }
  }
}
